import { render, staticRenderFns } from "./site-view-page.vue?vue&type=template&id=813b81b4&"
import script from "./site-view-page.vue?vue&type=script&lang=js&"
export * from "./site-view-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports